import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttempts } from '../components/FailedAttempts';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-dark-bg selection:bg-brand-orange selection:text-white" data-id="element-157">
      <Hero data-id="element-158" />
      <OpeningHook data-id="element-159" />
      <ProblemSection data-id="element-160" />
      <FailedAttempts data-id="element-161" />
      <UniqueMechanism data-id="element-162" />
      <WhatYouGet data-id="element-163" />
      <WhoIsFor data-id="element-164" />
      <HowItWorks data-id="element-165" />
      <ProofSection data-id="element-166" />
      <FAQSection data-id="element-167" />
      <OfferBlock data-id="element-168" />
      <Footer data-id="element-169" />
    </main>;
}